import React from "react";
import DatePicker from "react-pikaday-datepicker";
import classNames from "classnames";
import moment from "moment-timezone";
import includes from "lodash/includes";
import CustomEvent from "custom-event";

interface DayPickerState {
  isFocused: boolean;
  isDirty: boolean;
  date: string;
}

interface DayPickerProps {
  externalFieldToStoreValue?: any;
  fieldName?: any;
  disabledDays?: string[];
  minDate?: string | Date;
  maxDate?: string | Date;
  errorMessage?: string;
  onChangeDate?: Function;
  initialValue?: string | Date;
}

class DayPicker extends React.Component<DayPickerProps, DayPickerState> {
  wrap: Element = null;

  constructor(props: DayPickerProps) {
    super(props);

    this.state = {
      isFocused: false,
      isDirty: false,
      date: null
    };

    this.changeDate = this.changeDate.bind(this);

    this.updateExternalField();
    document.addEventListener("click", e => this.handleDocClick(e));
  }

  componentDidUpdate() {
    this.updateExternalField();
  }

  updateExternalField() {
    if (!this.props.externalFieldToStoreValue) {
      return;
    }
    const { date } = this.state;
    const isValid = moment(date).isValid();

    if (isValid) {
      this.props.externalFieldToStoreValue.value = date;
    } else {
      this.props.externalFieldToStoreValue.value = "";
    }
  }

  handleDocClick(e: any) {
    if (!this.state.isFocused) return;

    if (this.wrap) {
      if (!this.wrap.contains(e.target)) {
        this.blur();
      }
    }
  }

  focus(): void {
    this.setState({ isFocused: true });
  }
  blur(): void {
    this.setState({ isFocused: false });
  }

  changeDate(date): void {
    this.setState({ isFocused: false, isDirty: true, date });
    const evt = new CustomEvent("dayPickerChanged", { detail: { date } });
    if (this.props.onChangeDate) {
      const formatted = moment(date).format("DD/MM/YYYY");
      this.props.onChangeDate.call(this, { date, formatted });
    }
    window.dispatchEvent(evt);
  }

  isDayDisabled(day, disabledDays): boolean {
    const dayName = moment(new Date(day)).format("dddd");
    return includes(disabledDays, dayName);
  }

  render() {
    const { isFocused, isDirty, date } = this.state;
    const { fieldName, disabledDays, minDate, maxDate, initialValue } = this.props;
    const isValid = isDirty ? moment(date).isValid() : true;
    const wrapClass = classNames({
      datepicker__fieldWrap: true,
      "is-focused": isFocused
    });

    return (
      <div ref={item => (this.wrap = item)}>
        <div className={wrapClass} onClick={() => this.focus()}>
          <DatePicker
            className={`text datepickerfield ${isValid ? "" : "input-validation-error"}`}
            name={fieldName}
            format="DD/MM/YYYY"
            minDate={minDate ? moment(minDate).toDate() : moment().toDate()}
            maxDate={maxDate ? moment(maxDate).toDate() : null}
            value={date != null ? new Date(date) : initialValue != null ? new Date(initialValue) : null}
            onChange={this.changeDate}
            readOnly={true}
            id="datepickerfield"
            disableDayFn={day => this.isDayDisabled(day, disabledDays)}
          />
        </div>
      </div>
    );
  }
}

export default DayPicker;
